import React, { useState } from "react";
import {
  SelectChangeEvent,
  Box,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  useTheme,
} from "@mui/material";
import UserHeader, { transitionDuration } from "./UserHeader";

interface FilterBarProps {
  onFilterChange: (field: string, value: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ onFilterChange }) => {
  const theme = useTheme();
  const [filterField, setFilterField] = useState<string>("login");
  const [filterValue, setFilterValue] = useState<string>("");

  const handleFieldChange = (event: SelectChangeEvent<string>) => {
    const newField = event.target.value as string;
    setFilterField(newField);
    onFilterChange(newField, filterValue);
  };

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setFilterValue(newValue);
    onFilterChange(filterField, newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center", // Centraliza verticalmente
        gap: 1,
        padding: "12px 20px", // Menor padding vertical
        border: `1px solid ${theme.palette.mode === "dark" ? "#444" : "#ccc"}`,
        borderRadius: "8px",
        boxShadow:
          theme.palette.mode === "dark"
            ? "0px 2px 4px rgba(0, 0, 0, 0.6)"
            : "0px 2px 4px rgba(0, 0, 0, 0.1)",
        backgroundColor: theme.palette.mode === "dark" ? "#2c2c2c" : "#f5f5f5",
        transition: `all ${transitionDuration}`,
        width: "fit-content",
        "@media (max-width: 600px)": {
          flexDirection: "column",
          width: "100%",
        },
      }}
    >
      {/* Dropdown com altura e alinhamento ajustados */}
      <FormControl
  variant="outlined"
  size="small"
  sx={{
    width: "150px",
    "& .MuiOutlinedInput-root": {
      height: "32px",
      display: "flex",
      alignItems: "center", // Mantém o alinhamento vertical
    },
  }}
>
  <InputLabel sx={{ fontSize: "0.825rem", top: "-4px" }}>Filtrar por</InputLabel>
  <Select
    value={filterField}
    onChange={handleFieldChange}
    label="Filtrar por"
    sx={{
      fontSize: "0.875rem",
      "& .MuiSelect-select": {
        textAlign: "left", // Alinha o texto à esquerda
        paddingLeft: "12px", // Ajuste opcional para o padding interno
      },
    }}
  >
    <MenuItem value="login">Login</MenuItem>
    <MenuItem value="fullName">Nome Completo</MenuItem>
  </Select>
</FormControl>

      {/* TextField com altura e alinhamento ajustados */}
      <TextField
        size="small"
        variant="outlined"
        label="Pesquisar"
        value={filterValue}
        onChange={handleValueChange}
        sx={{
          width: "200px",
          "& .MuiOutlinedInput-root": {
            height: "32px", // Ajusta a altura
            display: "flex",
            alignItems: "center", // Centraliza o conteúdo verticalmente
          },
          "& .MuiInputLabel-root": {
            fontSize: "1em", // Reduz o tamanho da label
            top: "-4px", // Ajusta o posicionamento vertical da label
          },
        }}
      />
    </Box>
  );
};

export default FilterBar;
